export default __webpack_public_path__ + "static/media/camera_icon.7015a8ea.svg";